export default __webpack_public_path__ + "static/media/thought-catalog.9f200cfc.jpg";